import Vue from 'vue';
import App from './pages/Index.vue';
import './assets/css/index.css';

Vue.config.productionTip = false;

new Vue({
  render: (h) => h(App, { props: { platform: 'android' } }),
}).$mount('#app');
